import { AHIcon, AHSeparator, AHText, Box, TouchableBox } from "arkh";
import React from "react";
import { useFragment, graphql } from "react-relay";
import { TeamUrgentSignals_team$key } from "./__generated__/TeamUrgentSignals_team.graphql";
import { SignalListItem } from "../../../Signals/SignalListItem";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { TeamSectionHeaderCTAButton } from "./TeamSectionHeaderCTAButton";
import { FormattedMessage } from "react-intl";
import { SignalUnreadLabel } from "./TeamFeatureBar/SignalUnreadLabel";
import { useSizeClass } from "../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

export function TeamUrgentSignals(props: {
  team: TeamUrgentSignals_team$key;
  onOpenSignal: (signalId: string) => void;
  onOpenSignals: () => void;
}) {
  const team = useFragment(
    graphql`
      fragment TeamUrgentSignals_team on Team {
        store {
          activeSignalCount
          hasHighPrioritySignals
          unreadSignalCount
        }
        urgentSignals {
          id
          ...SignalListItem_signal
        }
      }
    `,
    props.team
  );
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const intl_tokens = useIntlTokens();
  if (!team.urgentSignals || team.urgentSignals.length === 0) {
    return null;
  }
  return (
    <Box spaceHorizontal="medium">
      <TouchableBox
        space={isCompact ? "small" : "medium"}
        color="surface"
        cornerRadiusTopLeft="large"
        cornerRadiusTopRight="large"
        style={{
          flexDirection: "row",
          alignItems: "center",
          borderWidth: 1,
          margin: -1,
          marginBottom: 0,
        }}
        borderColor="border-primary"
        onPress={() => {
          props.onOpenSignals();
        }}
      >
        <AHIcon type="signal" size="medium" />
        <AHText type="title" spaceLeft="small">
          {team.store.activeSignalCount}
        </AHText>
        <AHText type="subtitle" color="text-secondary" spaceLeft="small">
          {intl_tokens.Signals}
        </AHText>
        <Box style={{ flex: 1 }} />
        {team.store.unreadSignalCount > 0 ? (
          <AHText spaceRight="small">
            <SignalUnreadLabel unreadCount={team.store.unreadSignalCount} />
          </AHText>
        ) : null}
        {team.store.hasHighPrioritySignals ? (
          <Box spaceRight="small">
            <AHIcon type="prio" size="medium" />
          </Box>
        ) : null}
        <TeamSectionHeaderCTAButton
          ctaTitle={
            <FormattedMessage
              defaultMessage="More"
              description="TeamUrgentSignals more button"
            />
          }
        />
      </TouchableBox>
      {team.urgentSignals
        .filter((s) => s?.id)
        .map((signal, i) => (
          <React.Fragment key={signal.id}>
            {i !== 0 ? <AHSeparator /> : null}
            <SignalListItem
              key={signal.id}
              signal={signal}
              isLast={i === team.urgentSignals.length - 1}
              openSignal={props.onOpenSignal}
            />
          </React.Fragment>
        ))}
    </Box>
  );
}
